export function RunnerPlugin(_a) {
    var handler = _a.handler;
    return {
        onKeyDown: function (event, editor, next) {
            // Handle enter
            if (handler && event.key === 'Enter' && (event.shiftKey || event.ctrlKey)) {
                // Submit on Enter
                event.preventDefault();
                handler(event);
                return editor;
            }
            return next();
        },
    };
}
//# sourceMappingURL=runner.js.map